// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp'
import { useCallback, useLayoutEffect, useRef } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { useReportMap, useReportIncidentSlice } from '../store';
import { addDraggableMarkerOnTap, addDragMarkerHandlers } from '../utils';

const engineType = H.Map.EngineType.HARP

const DEFAULT_MAP_OPTIONS: H.Map.Options = {
  engineType,
  center: { lat: 45.9432, lng: 24.9668 },
  // Romania's most extreme points https://en.wikipedia.org/wiki/List_of_extreme_points_of_Romania
  bounds: new H.geo.Rect(48.15, 20.19, 43.4, 29.4),
  pixelRatio: window.devicePixelRatio || 1,
  zoom: 0,
};

export function useInitializeReportIncidentMap() {
  const mapRef = useRef<HTMLElement>();
  const { map, setMap, disposeMap } = useReportMap();
  const { setIncidentLocation } = useReportIncidentSlice();

  const onResize = useCallback(() => {
    map?.getViewPort().resize();
  }, [map]);

  useResizeDetector({
    onResize,
    skipOnMount: true,
    targetRef: mapRef,
  });

  useLayoutEffect(() => {
    if (!process.env.REACT_APP_HERE_MAPS_API_KEY_APISANA || !mapRef.current) {
      return undefined;
    }

    const platform = new H.service.Platform({
      apikey: process.env.REACT_APP_HERE_MAPS_API_KEY_APISANA,
    });

    const layers = platform.createDefaultLayers({engineType});

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const hMap = new H.Map(mapRef.current, layers.raster.satellite.map, {
      ...DEFAULT_MAP_OPTIONS,
    });

    const events = new H.mapevents.MapEvents(hMap);
    const behavior = new H.mapevents.Behavior(events);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const ui = H.ui.UI.createDefault(hMap, layers);

    setMap(hMap);

    addDragMarkerHandlers(hMap, behavior, setIncidentLocation);

    addDraggableMarkerOnTap(hMap, setIncidentLocation);

    return () => {
      hMap.dispose();
      disposeMap();
    };
  }, [disposeMap, setIncidentLocation, setMap]);

  return { mapRef };
}
